<template>
    
<div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">

<header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
  <div class="relative md:w-56">
    <input class="border-2 border-gray-300 bg-white h-10 px-3 pr-10 rounded-lg text-sm focus:outline-none w-full" type="search" name="top_search" placeholder="Search" v-model="top_search" @keyup.enter="topSearchScript" >
    <button type="submit" class="absolute right-0 top-0 mt-2 mr-4 outline-none" @click="topSearchScript"><i class="fa fa-search" aria-hidden="true"></i></button>
  </div>

  <div v-if="isReport" class="mr-3"> 
    <button><a class="button-color text-white font-bold py-1 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-4 mt-10 inline-block" href="javascript:void(0)" @click="openReport()">Product Composition Report</a></button>
  </div>
 
</header>

</div>
   
</template>

<script>
  
export default {

  props: ['searchVal', 'isReport'],

  components: {
  },

  
  data(){
    return {
      top_search:this.searchVal,
    }
  },
  methods: {
        topSearchScript() {
          this.$emit('messageFromChild',this.top_search);
        },
        openReport() {
          this.$emit('openReport');
        }

    },
  
};

</script>